(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["fields"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.carousel').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
   slidesMargin: 20,
  arrows: false,
rtl: true,
          responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
      slidesMargin: 10
          }
        }
      ]
    });
  });

	$(".accordion-item .accordion-button").click(function(){
	
		if($(this).parent().parent().hasClass("accordion-item-active")) {
	$(".accordion-item").removeClass("accordion-item-active");
			$(this).parent().parent().removeClass("accordion-item-active");
		} else {
	$(".accordion-item").removeClass("accordion-item-active");
			$(this).parent().parent().addClass("accordion-item-active");
		}
	});

  } catch(e) { console.error(e); }
})();

})();
